module.exports = __webpack_public_path__ + "static/media/reset.5924f006.svg";